// @flow
import * as React from 'react';
import styled, {
  type StyledComponent,
  type PropsWithTheme,
} from 'styled-components';

export type Props = $ReadOnly<{|
  wrap?: string,
  alignItems?: string,
  justifyContent?: string,
  flexDirection?: string,
  marginBottom?: string,
  marginTop?: string,
  marginRight?: string,
  marginLeft?: string,
  flex?: string,
  childSpacing?: string,
  children: React.Node,
  onClick?: (SyntheticMouseEvent<HTMLElement>) => void,
  style?: { +[string]: mixed },
  overflow?: string,
  gap?: string,
|}>;

export const spaceChildren = ({
  flexDirection = 'row',
  childSpacing,
}: {
  flexDirection?: string,
  childSpacing?: string,
}): string => {
  if (childSpacing) {
    return `> *:not(:last-child) {
        ${
          flexDirection === 'row' ? 'margin-right' : 'margin-bottom'
        }: ${childSpacing}
    }`;
  }
  return '';
};

const Flex: StyledComponent<Props, {}, HTMLDivElement> = styled.div`
  display: flex;
  flex-wrap: ${({ wrap = 'nowrap' }: PropsWithTheme<Props, { ... }>) => wrap};
  align-items: ${({
    alignItems = 'flex-start',
  }: PropsWithTheme<Props, { ... }>) => alignItems};
  justify-content: ${({
    justifyContent = 'flex-start',
  }: PropsWithTheme<Props, { ... }>) => justifyContent};
  flex-direction: ${({
    flexDirection = 'row',
  }: PropsWithTheme<Props, { ... }>) => flexDirection};
  margin-bottom: ${({ marginBottom = '0' }: PropsWithTheme<Props, { ... }>) =>
    marginBottom};
  margin-top: ${({ marginTop = '0' }: PropsWithTheme<Props, { ... }>) =>
    marginTop};
  margin-right: ${({ marginRight = '0' }: PropsWithTheme<Props, { ... }>) =>
    marginRight};
  margin-left: ${({ marginLeft = '0' }: PropsWithTheme<Props, { ... }>) =>
    marginLeft};
  flex: ${({ flex = 'initial' }: PropsWithTheme<Props, { ... }>) => flex};
  overflow: ${({ overflow = 'initial' }: PropsWithTheme<Props, { ... }>) =>
    overflow};
  gap: ${({ gap = '0' }: PropsWithTheme<Props, { ... }>) => gap};

  ${spaceChildren}
`;

export default Flex;
